import { Component, Input } from '@angular/core';
import { Store } from '@ngxs/store';
import { SetPortion } from '@moduurnv2/libs-orderingapp/src';

@Component({
  selector: 'wj-portion-list',
  templateUrl: 'wj-portion-list.component.html',
  styleUrls: ['wj-portion-list.component.scss'],
})
export class WJPortionListComponent {
  @Input('portions') portions;

  constructor(private store: Store) {}
  ngAfterViewInit() {
    // this.portions.forEach((portion) => {
    //   if (portion.isDefault) this.store.dispatch(new SetPortion(portion._id));
    // });
  }
  portionChange(event, portion) {
    this.store.dispatch(new SetPortion(portion._id));
  }

  get selectedPortion() {
    const foundSelected = this.portions.find((portion) => portion.selected);
    return foundSelected._id;
  }
}
